export default {
    title: 'Admin',
    exit: 'Sign out',

    create: 'Create',
    edit: 'Edit',
    save: 'Save',
    cancel: 'Cancel',

    navigation: {
        dashboard: 'Dashboard',
        users: 'Users',
        audit: 'Audit',
        settings: 'Settings',
        dicts: 'Dicts',
        signout: 'Sign out',

        entities: {
            gps: 'GPs',
            funds: 'Funds',
            'funds-perf': 'Funds Performance',
            companies: 'Companies',
            'companies-evol': 'Companies Evolution',
            trans: 'Transactions',
            'trans-perf': 'Transactions Performance',
            lps: 'Limited Partners',
            'lps-investments': 'LP Investments',
            'lps-secondary-trans': 'LP Secondary Transactions',
        },

        schema: {
            main: 'Schema Builder',
            gps: 'GPs',
            funds: 'Funds',
            fundsPerf: 'Funds Performance',
            companies: 'Companies',
            companiesEvol: 'Companies Evolution',
            trans: 'Transactions',
            transPerf: 'Transactions Performance',
            lps: 'Limited Partners',
            lpsInvestments: 'LP Investments',
            lpsSecondaryTrans: 'LP Secondary Transactions',
            dicts: 'Dicts',
            transforms: 'Transforms',
            styles: 'Styles',
        },

        imports: {
            default: 'Imports',
            list: 'Imports',
            create: 'Import',
            validations: 'Validations',
        },
    },
}
